import React, { useState } from 'react';
import { createUser } from '../../api/userApi';
import './CreateUser.css';  // Import the CSS file for styling

const CreateUser = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        verifiedPhone: false,
        preferredContactMethod: 'email',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await createUser(formData);
            console.log(response);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="form-container">
            <h2>Create User</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="firstName">First Name</label>
                    <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First Name" />
                </div>
                <div className="form-group">
                    <label htmlFor="lastName">Last Name</label>
                    <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name" />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email" />
                </div>
                <div className="form-group">
                    <label htmlFor="phoneNumber">Phone Number</label>
                    <input type="text" id="phoneNumber" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} placeholder="Phone Number" />
                </div>
                <div className="form-group">
                    <label htmlFor="preferredContactMethod">Preferred Contact Method</label>
                    <select id="preferredContactMethod" name="preferredContactMethod" value={formData.preferredContactMethod} onChange={handleChange}>
                        <option value="email">Email</option>
                        <option value="text">Text</option>
                        <option value="call">Call</option>
                    </select>
                </div>
                <button type="submit" className="submit-button">Create User</button>
            </form>
        </div>
    );
};

export default CreateUser;
